import { render, staticRenderFns } from "./wdscSet.vue?vue&type=template&id=47f168c4&scoped=true&"
import script from "./wdscSet.vue?vue&type=script&lang=js&"
export * from "./wdscSet.vue?vue&type=script&lang=js&"
import style0 from "./wdscSet.vue?vue&type=style&index=0&id=47f168c4&prod&lang=scss&scoped=true&"
import style1 from "./wdscSet.vue?vue&type=style&index=1&id=47f168c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f168c4",
  null
  
)

export default component.exports